import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Home = () => {
  const companies = [
    {
      name: "SIF 4 Golf Simulator International Company Private Limited",
      description: "Pioneering the future of golf through advanced simulation, professional training, and immersive digital experiences.",
      imageUrl: "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?q=80&w=2070&auto=format&fit=crop",
      services: [
        {
          title: "Simulator",
          description: "Providing world-class golf simulation solutions through advanced technology-driven platforms, enabling professional training, recreational engagement, tournament management, and immersive golfing experiences within controlled indoor environments.",
          imageUrl: "https://images.pexels.com/photos/31212256/pexels-photo-31212256.jpeg?cs=srgb&dl=pexels-swingzone-swingzone-2150575315-31212256.jpg&fm=jpg",
          icon: "📊"
        },
        {
          title: "Pro Shop",
          description: "A premium golf retail and equipment division offering high-quality golf accessories, apparel, professional equipment, training aids, and customized golfing solutions to meet the requirements of beginners, enthusiasts, and professional golfers.",
          imageUrl: "https://media.istockphoto.com/id/2190489125/photo/golf-equipment-display-with-polished-clubs-and-branded-apparel.jpg?s=612x612&w=0&k=20&c=9b35UDab3welPpsudHhh5hX8JUxXtHNMueXAxohMa74=",
          icon: "🛒"
        },
        {
          title: "Academy",
          description: "A professionally managed golf education and skill development platform focused on delivering structured coaching programs, performance enhancement training, talent nurturing, and player development under expert supervision.",
          imageUrl: "https://www.marangaroogolf.com.au/wp-content/uploads/sites/28/2024/06/nathan-jennings-FmhOm8RjoW8-unsplash-scaled.jpg",
          icon: "🏌️"
        },
        {
          title: "Mobile Game",
          description: "Focused on the development and management of digital golf gaming ecosystems, offering engaging mobile-based gaming experiences, virtual tournaments, skill-based interaction, and user engagement through innovative technology solutions.",
          imageUrl: "/images/mobile_game.png",
          icon: "📱"
        }
      ]
    },
    {
      name: "SIF 4 Facilities Management Company",
      description: "Delivering excellence in operational efficiency and property management.",
      imageUrl: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop",
      services: [
        {
          title: "Facility",
          description: "Delivering integrated facility management services encompassing operational efficiency, infrastructure maintenance, housekeeping, administrative support, and end-to-end property management solutions for corporate, commercial, and institutional establishments.",
          imageUrl: "/images/facility_management.png",
          icon: "🏢"
        },
        {
          title: "Security",
          description: "Providing professional security and surveillance solutions through trained personnel, risk mitigation strategies, safety compliance, access management, and comprehensive asset protection services.",
          imageUrl: "/images/security.png",
          icon: "🛡️"
        },
        {
          title: "Other Services",
          description: "Offering customized business support and operational services tailored to client-specific requirements, ensuring seamless execution, workforce optimization, and enhanced organizational productivity.",
          imageUrl: "https://images.unsplash.com/photo-1556761175-4b46a572b786?q=80&w=1974&auto=format&fit=crop",
          icon: "💼"
        }
      ]
    },
    {
      name: "SIF Nutrition Company Private Limited",
      description: "Empowering individuals through holistic wellness and scientifically aligned nutritional solutions.",
      imageUrl: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=2080&auto=format&fit=crop",
      services: [
        {
          title: "Herbal Life",
          description: "Promoting health and wellness through premium nutrition and lifestyle enhancement solutions aimed at supporting fitness, balanced nutrition, preventive healthcare, and sustainable well-being.",
          imageUrl: "/images/herbal_life.png",
          icon: "🌿"
        },
        {
          title: "Amura",
          description: "Delivering scientifically aligned nutritional and wellness products designed to improve vitality, immunity, and overall health while promoting a balanced and performance-oriented lifestyle.",
          imageUrl: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?q=80&w=2053&auto=format&fit=crop",
          icon: "🍎"
        },
        {
          title: "Brain Yoga",
          description: "A specialized wellness initiative focused on cognitive enhancement, mental wellness, emotional balance, concentration improvement, and stress management through structured mind-development practices.",
          imageUrl: "/images/brain_yoga.png",
          icon: "🧘‍♂️"
        }
      ]
    },
    {
      name: "SIF 4 Real Estate Company Private Limited",
      description: "Creating value through strategic property investments, development, and comprehensive real estate services.",
      imageUrl: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop",
      services: [
        {
          title: "Property Sale",
          description: "Facilitating professional real estate sales services across residential, commercial, and investment segments with a focus on market expertise, transparency, client satisfaction, and value-driven transactions.",
          imageUrl: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format&fit=crop",
          icon: "🏠"
        },
        {
          title: "Property Purchase",
          description: "Providing comprehensive property acquisition support, including advisory, evaluation, due diligence, negotiation, and documentation assistance to ensure secure and strategic investments.",
          imageUrl: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=1996&auto=format&fit=crop",
          icon: "🔑"
        },
        {
          title: "Property Construction",
          description: "Executing high-quality residential, commercial, and infrastructure development projects through professional planning, engineering excellence, project management, and timely delivery standards.",
          imageUrl: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2071&auto=format&fit=crop",
          icon: "🏗️"
        }
      ]
    }
  ];

  const uspItems = [
    {
      number: "01",
      title: "Affordable Access",
      description: "Demystifying golf through innovative membership models and pay-per-play options that make golf accessible to everyone."
    },
    {
      number: "02",
      title: "International Standards",
      description: "World-class facilities and coaching methodologies that match global benchmarks for excellence."
    },
    {
      number: "03",
      title: "Technology-Driven",
      description: "Advanced simulators, data analytics, and AI-powered training for precision improvement."
    },
    {
      number: "04",
      title: "Personalized Coaching",
      description: "Tailored training programs that adapt to individual needs, goals, and skill levels."
    }
  ];

  const blogPosts = [
    {
      id: 1,
      title: "Improving Your Swing Technique",
      excerpt: "Expert tips and techniques to perfect your golf swing and improve your game consistency.",
      category: "Golf Tips",
      imageUrl: "https://images.unsplash.com/photo-1591491659771-3f9777200049?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z29sZiUyMHN3aW5nfGVufDB8fDB8fHww"
    },
    {
      id: 2,
      title: "Choosing the Right Golf Clubs",
      excerpt: "A comprehensive guide to selecting golf clubs that match your playing style and skill level.",
      category: "Equipment",
      imageUrl: "https://plus.unsplash.com/premium_photo-1663012820207-0b054fdd5b03?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Z29sZiUyMGZpZWxkfGVufDB8fDB8fHww"
    },
    {
      id: 3,
      title: "Golf Course Strategy Guide",
      excerpt: "Learn how to read golf courses and develop winning strategies for different course layouts.",
      category: "Strategy",
      imageUrl: "https://plus.unsplash.com/premium_photo-1661773279734-9f1adc050d4e?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Z29sZmluZ3xlbnwwfHwwfHx8MA%3D%3D"
    }
  ];

 const testimonials = [
    /*{
      name: "Rajesh Kumar",
      role: "Beginner to Intermediate",
      testimonial: "The systematic coaching approach transformed my game completely. From a complete beginner to now playing confidently in tournaments.",
      rating: 5
    },
    {
      name: "Priya Sharma",
      role: "Corporate Executive",
      testimonial: "The simulators are fantastic for practice during weekdays. The data analytics helped me understand my swing better than ever before.",
      rating: 5
    },
    {
      name: "Arvind Patel",
      role: "Junior Golfer Parent",
      testimonial: "My son's progress in the youth development program has been incredible. The coaches are amazing with kids and very professional.",
      rating: 5
    }*/
  ];

  /*
    Commands to control the Testimonial Section:
    - Show via env var (Windows):
        npm run start:show-testimonials
      (this sets `REACT_APP_SHOW_TESTIMONIALS=true` then runs the dev server)
    - Show via URL param in browser:
        add `?showTestimonials=true` to the page URL
  */
  const showTestimonials = (() => {
    try {
      const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
      const param = params && params.get('showTestimonials') === 'true';
      const env = process.env.REACT_APP_SHOW_TESTIMONIALS === 'true';
      return !!(param || env);
    } catch (e) {
      return process.env.REACT_APP_SHOW_TESTIMONIALS === 'true';
    }
  })();

  const stats = [
    { value: "1000+", label: "Students Trained", icon: "👨‍🎓" },
    { value: "24/7", label: "Simulator Access", icon: "🖥️" },
    { value: "15+", label: "Certified Coaches", icon: "🏌️" },
    { value: "98%", label: "Satisfaction Rate", icon: "⭐" }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="home-hero-section">
        <div className="hero-overlay"></div>

        {/* Video Background */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="hero-video"
        >
          <source src="/images/golf.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <Container className="position-relative z-3 h-100">
          <Row className="h-100 align-items-center justify-content-center">
            <Col xs={12} lg={10} xl={8} className="text-center">
              <h1 className="hero-title mb-4">Making Golf Accessible. Worldwide.</h1>
              <p className="hero-subtitle mb-5">
                Discover a place where peace and relaxation will surround you from the moment you step through our doors.
              </p>
              <div className="hero-cta d-flex flex-column flex-sm-row justify-content-center gap-3">
                <a href="/services" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                  Explore Services
                </a>
                <a href="/academy" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                  Join the Academy
                </a>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Scroll Indicator - positioned relative to the section */}
        <div className="scroll-indicator">
          <div className="scroll-text">Scroll to Explore</div>
          <div className="scroll-arrow">↓</div>
        </div>
      </section>

      {/* Our Ecosystem Section */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Our Corporate Ecosystem</h2>
              <p className="section-subtitle">
                A diversified portfolio of companies delivering excellence across golf, facility management, nutrition, and real estate.
              </p>
            </Col>
          </Row>

          {companies.map((company, index) => (
            <div key={index} className="company-section mb-4 mb-md-5 p-3 p-sm-4 p-md-5 bg-white shadow-sm" style={{ borderRadius: '1rem' }}>
              <Row className="align-items-center mb-4 pb-4 border-bottom">
                <Col lg={5} className="mb-4 mb-lg-0">
                  <div className="company-image-container overflow-hidden shadow-sm" style={{ borderRadius: '12px' }}>
                    <img src={company.imageUrl} alt={company.name} className="img-fluid w-100 company-img" style={{ objectFit: 'cover' }} />
                  </div>
                </Col>
                <Col lg={7}>
                  <h3 className="company-title mb-3" style={{ color: 'var(--primary-green)', fontWeight: '600' }}>{company.name}</h3>
                  <p className="company-desc mb-0" style={{ color: 'var(--text-light)', lineHeight: '1.6' }}>{company.description}</p>
                </Col>
              </Row>
              <h4 className="mb-4 h5 fw-bold" style={{ color: 'var(--muted-gold)' }}>Divisions & Services</h4>
              <Row className="g-4">
                {company.services.map((service, sIndex) => (
                  <Col md={6} lg={company.services.length === 4 ? 3 : 4} key={sIndex}>
                    <div className="card-modern h-100 d-flex flex-column">
                      <div
                        className="card-img"
                        style={{ backgroundImage: `url(${service.imageUrl})` }}
                      >
                        <div className="card-img-icon">
                          {service.icon}
                        </div>
                      </div>

                      <div className="card-content d-flex flex-column flex-grow-1 p-4">
                        <h3 className="card-title mb-3">{service.title}</h3>
                        <p className="card-text mb-4 flex-grow-1">
                          {service.description}
                        </p>
                        <a
                          href={`/services#${service.title.toLowerCase().replace(/\s+/g, '-')}`}
                          className="btn btn-gold w-100 mt-auto"
                        >
                          Learn More
                        </a>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </Container>
      </section>

      {/* Mission & Vision Section */}
      <section className="section-padding bg-mission">
        <Container className="position-relative z-3">
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <div className="section-header mb-4">
                <h2 className="section-title mb-0">
                  <span className="text-gold">Our</span> Mission & Vision
                </h2>
              </div>
              <p className="section-subtitle text-white">
                Shaping the future of golf through innovation, excellence, and passion
              </p>
            </Col>
          </Row>

          <Row className="g-4 g-lg-5">
            <Col xs={12} lg={6} className="mb-4 mb-lg-0">
              {/* Mission Card */}
              <div className="mission-card card-modern h-100">
                <div className="card-content p-4 p-md-5">
                  <div className="d-flex align-items-start mb-4">
                    <div className="mission-icon me-4">M</div>
                    <div>
                      <h3 className="card-title mb-3">Mission</h3>
                      <p className="card-text">
                        To democratize golf by making premium experiences accessible and affordable for all enthusiasts,
                        breaking traditional barriers while maintaining uncompromising standards of excellence.
                      </p>
                    </div>
                  </div>

                  <div className="card-stats mt-4 pt-4">
                    <Row className="g-3">
                      <Col xs={6}>
                        <div className="stat-box">
                          <div className="stat-number">1000+</div>
                          <div className="stat-label">Students Trained</div>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="stat-box">
                          <div className="stat-number">15+</div>
                          <div className="stat-label">Certified Coaches</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} lg={6}>
              {/* Vision Card */}
              <div className="vision-card card-modern h-100">
                <div className="card-content p-4 p-md-5">
                  <div className="d-flex align-items-start mb-4">
                    <div className="vision-icon me-4">V</div>
                    <div>
                      <h3 className="card-title mb-3">Vision</h3>
                      <p className="card-text">
                        To cultivate India's next generation of world-class golfers through innovative coaching,
                        cutting-edge technology, and a holistic development ecosystem that creates champions.
                      </p>
                    </div>
                  </div>
      
                  <div className="card-stats mt-4 pt-4">
                    <Row className="g-3">
                      <Col xs={6}>
                        <div className="stat-box">
                          <div className="stat-number">24/7</div>
                          <div className="stat-label">Access</div>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="stat-box">
                          <div className="stat-number">98%</div>
                          <div className="stat-label">Satisfaction</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Call to Action */}
          <Row className="mt-5">
            <Col xs={12} lg={8} className="mx-auto text-center">
              <div className="cta-card p-4 p-md-5">
                <p className="cta-title mb-4">Ready to transform your golf journey?</p>
                <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                  <a href="/academy" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                    Join Our Academy
                  </a>
                  <a href="/contact" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                    Schedule a Tour
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why G4I Section */}
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Why Choose Golf4International</h2>
              <p className="section-subtitle">
                Our unique approach combines tradition with innovation to deliver exceptional golf experiences.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {uspItems.map((item, index) => (
              <Col xs={12} lg={6} key={index}>
                <div className="usp-card card-modern h-100">
                  <div className="card-content p-4">
                    <div className="d-flex align-items-start">
                      <div className="usp-number me-4">{item.number}</div>
                      <div>
                        <h3 className="card-title mb-2">{item.title}</h3>
                        <p className="card-text mb-0">{item.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Stats Section */}
          <Row className="mt-5 pt-5">
            <Col xs={12} className="text-center mb-4">
              <h3 className="section-title mb-3">Our Impact</h3>
            </Col>
            {stats.map((stat, index) => (
              <Col xs={6} md={3} className="text-center mb-4" key={index}>
                <div className="stats-item">
                  <div className="stats-icon mb-3">
                    {stat.icon}
                  </div>
                  <h3 className="stat-number mb-2">{stat.value}</h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Blog Preview Section */}
      <section className="section-padding bg-soft-sage">
        <Container>
          {/* Header centered */}
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Latest Golf Insights</h2>
              <p className="section-subtitle">
                Stay updated with expert articles, tips, and news from the world of golf
              </p>
            </Col>
          </Row>

          {/* Blog Cards */}
          <Row className="g-4">
            {blogPosts.map((post) => (
              <Col xs={12} md={6} lg={4} key={post.id}>
                <div className="card-modern h-100 d-flex flex-column">
                  <div
                    className="card-img"
                    style={{ backgroundImage: `url(${post.imageUrl})` }}
                  >
                    <div className="card-category">
                      {post.category}
                    </div>
                  </div>

                  <div className="card-content d-flex flex-column flex-grow-1 p-4">
                    <h3 className="card-title mb-3">{post.title}</h3>
                    <p className="card-text mb-4 flex-grow-1">
                      {post.excerpt}
                    </p>
                    <a href={`/blog/${post.id}`} className="btn btn-gold w-100 mt-auto">
                      Read Article
                    </a>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* View All Button */}
          <Row className="mt-4">
            <Col xs={12} className="text-center">
              <a href="/blog" className="btn btn-gold btn-lg px-5">View All Articles</a>
            </Col>
          </Row>

          {/* Blog Categories */}
          <Row className="mt-5">
            <Col xs={12} className="text-center">
              <div className="categories-card p-4 p-md-5">
                <h3 className="categories-title mb-4">Explore More Topics</h3>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  {["Technology", "Academy", "Business", "Sustainability"].map((category, index) => (
                    <a
                      key={index}
                      href={`/blog?category=${category}`}
                      className="btn btn-gold btn-category"
                    >
                      {category}
                    </a>
                  ))}
                </div>
              </div>
            </Col>
          </Row>

          {/* Newsletter Signup */}
          <Row className="mt-5">
            <Col xs={12} lg={8} className="mx-auto">
              <div className="newsletter-card p-4 p-md-5 text-center">
                <div className="newsletter-icon mb-4">
                  <span>✉️</span>
                </div>
                <h3 className="newsletter-title mb-3">Get Golf Tips & Updates</h3>
                <p className="newsletter-text mb-4">
                  Subscribe to our newsletter for exclusive golf tips, industry insights, tournament updates,
                  and special offers delivered to your inbox.
                </p>
                <div className="newsletter-form d-flex flex-column flex-md-row gap-2 justify-content-center align-items-stretch align-items-md-center w-100">
                  <input
                    type="email"
                    className="form-control newsletter-input flex-grow-1"
                    placeholder="Enter your email address"
                  />
                  <button
                    className="btn btn-gold-filled newsletter-btn"
                    type="button"
                  >
                    Subscribe
                  </button>
                </div>
                <p className="newsletter-note small mt-3 mb-0">
                  We respect your privacy. Unsubscribe at any time.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonial Section — commented out using JSX block comment */}
      {/*
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">What Our Members Say</h2>
              <p className="section-subtitle">
                Join hundreds of satisfied golfers who have transformed their game with us
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {testimonials.map((testimonial, index) => (
              <Col xs={12} md={6} lg={4} key={index}>
                <div className="testimonial-card card-modern h-100">
                  <div className="card-content p-4">
                    <div className="testimonial-header d-flex align-items-center mb-3">
                      <div className="testimonial-avatar me-3">
                        <span>👤</span>
                      </div>
                      <div>
                        <h5 className="testimonial-name mb-1">{testimonial.name}</h5>
                        <p className="testimonial-role small mb-0">{testimonial.role}</p>
                      </div>
                    </div>
                    <div className="testimonial-rating mb-3">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <span key={i} className="star">★</span>
                      ))}
                    </div>
                    <p className="testimonial-text mb-0">"{testimonial.testimonial}"</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      */}

      {/* Global Vision Section - FIXED: Text visibility */}
      <section className="section-padding bg-global-vision">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Global Vision & Scale</h2>
              <p className="section-subtitle">
                Delivering premium golf experiences worldwide through cutting-edge technology and international expertise
              </p>
            </Col>
          </Row>

          <Row className="align-items-center g-4 g-lg-5">
            <Col xs={12} lg={6} className="mb-5 mb-lg-0">
              <div className="global-content">
                <div className="global-icons d-flex flex-wrap gap-4 mb-4">
                  <div className="global-icon-item text-center">
                    <div className="icon-circle bg-gold mb-2">
                      <span className="icon-text">🇮🇳</span>
                    </div>
                    <h4 className="global-icon-title mb-1">India First</h4>
                    <p className="global-icon-text mb-0">Homegrown Excellence</p>
                  </div>

                  <div className="global-icon-item text-center">
                    <div className="icon-circle bg-green mb-2">
                      <span className="icon-text">🌍</span>
                    </div>
                    <h4 className="global-icon-title mb-1">Global Standards</h4>
                    <p className="global-icon-text mb-0">World-Class Quality</p>
                  </div>
                </div>

                <p className="global-description mb-4">
                  Our expansion strategy focuses on bringing world-class facilities to major cities across India,
                  making premium golf experiences accessible through cutting-edge technology and international expertise.
                </p>

                {/*
                <div className="global-locations d-flex flex-wrap gap-3">
                  <div className="location-card">
                    <h5 className="location-title mb-2">Current Locations</h5>
                    <div className="location-list">
                      <div className="location-item">🏢 Delhi Headquarters</div>
                      <div className="location-item">🏢 Mumbai Center</div>
                      <div className="location-item">🏢 Bengaluru Hub</div>
                    </div>
                  </div>

                  <div className="location-card">
                    <h5 className="location-title mb-2">Coming Soon</h5>
                    <div className="location-list">
                      <div className="location-item">📍 Chennai 2024</div>
                      <div className="location-item">📍 Kolkata 2024</div>
                      <div className="location-item">📍 Hyderabad 2025</div>
                    </div>
                  </div>
                </div>
                */}
              </div>
            </Col>

            <Col xs={12} lg={6}>
              <div className="global-image rounded">
                <div className="image-overlay p-4">
                  <h4 className="image-title mb-2">International Partnerships</h4>
                  <p className="image-text mb-0">
                    Collaborating with global golf institutions for excellence
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section> 

      {/* CSS Styles */}
      <style jsx>{`
        /* ========== BASE STYLES ========== */
        :root {
          --primary-green: #1F3D2B;
          --muted-gold: #B59A5A;
          --soft-sage: #f0f7f3;
          --text-dark: #333333;
          --text-light: #666666;
          --white: #ffffff;
        }
        
        /* ========== TYPOGRAPHY ========== */
        .hero-title {
          font-size: clamp(2rem, 5vw, 3.5rem);
          color: var(--muted-gold);
          font-weight: 600;
          line-height: 1.2;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }
        
        .hero-subtitle {
          font-size: clamp(1rem, 2.5vw, 1.5rem);
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.95);
          margin-bottom: 2.5rem;
          font-weight: 400;
        }
        
        .section-title {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          color: var(--primary-green);
          font-weight: 600;
          margin-bottom: 1rem;
          line-height: 1.2;
          font-family: 'Playfair Display', serif;
        }
        
        .section-subtitle {
          color: var(--text-light);
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          max-width: 700px;
          margin: 0 auto;
          font-weight: 400;
        }
        
        .card-title {
          font-size: clamp(1.1rem, 1.8vw, 1.3rem);
          color: var(--primary-green);
          font-weight: 600;
          margin-bottom: 1rem;
          line-height: 1.4;
        }
        
        .card-text {
          color: var(--text-light);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.6;
          margin-bottom: 1.5rem;
        }
        
        /* ========== SECTION SPACING ========== */
        .section-padding {
          padding: clamp(3rem, 6vw, 5rem) 0;
        }
        
        /* ========== BUTTONS ========== */
        .btn-gold-filled {
          background-color: var(--muted-gold);
          color: var(--primary-green);
          border: none;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          text-decoration: none;
          display: inline-block;
          cursor: pointer;
        }
        
        .btn-gold-filled:hover {
          background-color: #d4b56e;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
          text-decoration: none;
          color: var(--primary-green);
        }
        
        .btn-gold {
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(5px);
          color: var(--muted-gold);
          border: 2px solid var(--muted-gold);
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          text-decoration: none;
          display: inline-block;
          cursor: pointer;
        }
        
        .btn-gold:hover {
          background-color: rgba(181, 154, 90, 0.2);
          color: #d4b56e;
          border-color: #d4b56e;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
          text-decoration: none;
        }
        
        .btn-lg {
          padding: clamp(12px, 2vw, 14px) clamp(24px, 3vw, 32px);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        .btn-category {
          padding: 10px 24px;
          border-radius: 25px;
          font-size: 0.9rem;
        }
        
        /* ========== HERO SECTION ========== */
        .home-hero-section {
          height: 70vh;
          min-height: 550px;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding-top: 80px;
        }
        
        .hero-video {
          position: absolute;
          top: 50%;
          left: 50%;
          min-width: 100%;
          min-height: 100%;
          width: auto;
          height: auto;
          transform: translate(-50%, -50%);
          object-fit: cover;
          z-index: 1;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(31, 61, 43, 0.5) 0%, rgba(31, 61, 43, 0.7) 100%);
          z-index: 2;
        }
        
        .hero-cta {
          position: relative;
          z-index: 3;
        }
        
        /* ========== SCROLL INDICATOR - FIXED FOR MOBILE ========== */
        .scroll-indicator {
          position: absolute;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          color: white;
          text-align: center;
          z-index: 3;
          opacity: 0.8;
        }
        
        .scroll-text {
          font-size: 0.9rem;
          margin-bottom: 8px;
          white-space: nowrap;
        }
        
        .scroll-arrow {
          font-size: 1.5rem;
          animation: bounce 2s infinite;
        }
        
        /* ========== CARDS ========== */
        .card-modern {
          background: var(--white);
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        
        .card-modern:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }
        
        .card-img {
          height: clamp(200px, 30vw, 240px);
          width: 100%;
          background-size: cover;
          background-position: center;
          position: relative;
        }
        
        .card-img-icon {
          position: absolute;
          top: 20px;
          left: 20px;
          width: clamp(50px, 8vw, 60px);
          height: clamp(50px, 8vw, 60px);
          background-color: var(--white);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        
        .card-category {
          position: absolute;
          top: 15px;
          left: 15px;
          background-color: rgba(31, 61, 43, 0.9);
          color: var(--white);
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .card-content {
          flex: 1;
          padding: 1.5rem;
        }
        
        /* ========== MISSION & VISION SECTION ========== */
        .bg-mission {
          background: linear-gradient(135deg, var(--primary-green) 0%, #2D4A38 50%, var(--primary-green) 100%);
          position: relative;
        }
        
        .bg-mission .section-title {
          color: var(--white);
        }
        
        .bg-mission .section-subtitle {
          color: rgba(255, 255, 255, 0.9);
        }
        
        .text-gold {
          color: var(--muted-gold);
        }
        
        .text-white {
          color: var(--white);
        }
        
        .mission-icon,
        .vision-icon {
          width: clamp(50px, 8vw, 60px);
          height: clamp(50px, 8vw, 60px);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
          font-weight: 600;
          color: var(--white);
          flex-shrink: 0;
        }
        
        .mission-icon {
          background: linear-gradient(135deg, var(--muted-gold), #D4B573);
          box-shadow: 0 8px 20px rgba(181, 154, 90, 0.3);
        }
        
        .vision-icon {
          background: linear-gradient(135deg, var(--primary-green), #2D4A38);
          box-shadow: 0 8px 20px rgba(31, 61, 43, 0.3);
        }
        
        .card-stats {
          border-top: 1px solid rgba(181, 154, 90, 0.2);
          margin-top: 1.5rem;
          padding-top: 1.5rem;
        }
        
        .stat-box {
          text-align: center;
          padding: 1rem;
          border-radius: 8px;
          background-color: rgba(31, 61, 43, 0.05);
          border: 1px solid rgba(181, 154, 90, 0.1);
        }
        
        .stat-number {
          color: var(--muted-gold);
          font-size: clamp(1.25rem, 2vw, 1.5rem);
          font-weight: 600;
          margin-bottom: 0.25rem;
        }
        
        .stat-label {
          color: var(--primary-green);
          font-size: clamp(0.8rem, 1.2vw, 0.9rem);
          font-weight: 500;
        }
        
        .cta-card {
          background: linear-gradient(135deg, rgba(181, 154, 90, 0.1), rgba(31, 61, 43, 0.1));
          border: 1px solid rgba(181, 154, 90, 0.2);
          backdrop-filter: blur(10px);
          border-radius: 12px;
        }
        
        .cta-title {
          font-size: clamp(1.1rem, 2vw, 1.25rem);
          color: var(--white);
          font-weight: 600;
          margin-bottom: 1.5rem;
        }
        
        /* ========== USP CARDS ========== */
        .usp-number {
          width: clamp(50px, 8vw, 60px);
          height: clamp(50px, 8vw, 60px);
          background-color: var(--soft-sage);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1rem, 1.8vw, 1.25rem);
          font-weight: 600;
          color: var(--muted-gold);
          flex-shrink: 0;
        }
        
        /* ========== STATS ========== */
        .stats-item {
          transition: transform 0.3s ease;
        }
        
        .stats-item:hover {
          transform: translateY(-5px);
        }
        
        .stats-icon {
          width: clamp(60px, 10vw, 70px);
          height: clamp(60px, 10vw, 70px);
          background-color: var(--soft-sage);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.5rem, 2.5vw, 1.8rem);
          margin-bottom: 1rem;
        }
        
        /* ========== INFO CARDS ========== */
        .info-card {
          background-color: var(--soft-sage);
          border-radius: 12px;
          transition: transform 0.3s ease;
        }
        
        .info-card:hover {
          transform: translateY(-5px);
        }
        
        .info-title {
          color: var(--primary-green);
          font-weight: 600;
          font-size: clamp(1.1rem, 1.8vw, 1.25rem);
        }
        
        .info-text {
          color: var(--text-light);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.6;
        }
        
        /* ========== CATEGORIES CARD ========== */
        .categories-card {
          background-color: var(--white);
          border-radius: 12px;
          transition: transform 0.3s ease;
        }
        
        .categories-card:hover {
          transform: translateY(-5px);
        }
        
        .categories-title {
          color: var(--primary-green);
          font-weight: 600;
          font-size: clamp(1.1rem, 1.8vw, 1.25rem);
        }
        
        /* ========== NEWSLETTER CARD ========== */
        .newsletter-card {
          background-color: var(--white);
          border-radius: 12px;
          transition: transform 0.3s ease;
        }
        
        .newsletter-card:hover {
          transform: translateY(-5px);
        }
        
        .newsletter-icon {
          width: clamp(60px, 10vw, 70px);
          height: clamp(60px, 10vw, 70px);
          background-color: var(--soft-sage);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.5rem, 2.5vw, 1.8rem);
          color: var(--muted-gold);
          margin: 0 auto 1.5rem;
        }
        
        .newsletter-title {
          color: var(--primary-green);
          font-weight: 600;
          font-size: clamp(1.1rem, 1.8vw, 1.25rem);
        }
        
        .newsletter-text {
          color: var(--text-light);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.6;
        }
        
        .newsletter-input {
          padding: 14px 16px;
          font-size: 1rem;
          min-height: 50px;
          border: 1px solid rgba(31, 61, 43, 0.2);
          border-radius: 4px;
          width: 100%;
          color: var(--text-dark);
        }
        
        .newsletter-input::placeholder {
          color: var(--text-light) !important;
          opacity: 1 !important;
        }
        
        .newsletter-input:-ms-input-placeholder {
          color: var(--text-light) !important;
        }
        
        .newsletter-input::-ms-input-placeholder {
          color: var(--text-light) !important;
        }
        
        .newsletter-btn {
          min-height: 50px;
          white-space: nowrap;
          padding: 14px 32px;
          color: var(--primary-green) !important;
        }
        
        .newsletter-btn:hover {
          color: var(--primary-green) !important;
        }
        
        .newsletter-note {
          color: var(--text-light);
        }
        
        /* ========== TESTIMONIAL CARDS ========== */
        .testimonial-avatar {
          width: clamp(40px, 8vw, 50px);
          height: clamp(40px, 8vw, 50px);
          background-color: var(--soft-sage);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
        }
        
        .testimonial-name {
          color: var(--primary-green);
          font-weight: 600;
          font-size: clamp(0.95rem, 1.5vw, 1.05rem);
        }
        
        .testimonial-role {
          color: var(--text-light);
          font-size: clamp(0.8rem, 1.2vw, 0.9rem);
        }
        
        .testimonial-rating {
          color: var(--muted-gold);
        }
        
        .star {
          margin-right: 2px;
        }
        
        .testimonial-text {
          color: var(--text-light);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.6;
          font-style: italic;
        }
        
        /* ========== GLOBAL VISION SECTION - FIXED TEXT COLORS ========== */
        .bg-global-vision {
          background-color: var(--soft-sage);
          position: relative;
          overflow: hidden;
        }
        
        /* Remove the background image overlay since it's causing visibility issues */
        .global-bg-overlay {
          display: none;
        }
        
        /* Global Vision text colors - using theme colors */
        .bg-global-vision .section-title {
          color: var(--primary-green);
        }
        
        .bg-global-vision .section-subtitle {
          color: var(--text-light);
        }
        
        .global-content {
          color: var(--text-dark);
        }
        
        .global-icons {
          display: flex;
          flex-wrap: wrap;
          gap: clamp(1rem, 2vw, 1.5rem);
        }
        
        .icon-circle {
          width: clamp(60px, 10vw, 80px);
          height: clamp(60px, 10vw, 80px);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }
        
        .bg-gold {
          background-color: var(--muted-gold);
        }
        
        .bg-green {
          background-color: var(--primary-green);
        }
        
        .icon-text {
          font-size: clamp(1.25rem, 2.5vw, 1.5rem);
          color: var(--white);
        }
        
        .global-icon-title {
          color: var(--primary-green);
          font-weight: 600;
          font-size: clamp(0.95rem, 1.5vw, 1.05rem);
          margin-top: 0.5rem;
        }
        
        .global-icon-text {
          color: var(--text-light);
          font-size: clamp(0.8rem, 1.2vw, 0.9rem);
        }
        
        .global-description {
          color: var(--text-dark);
          font-size: clamp(0.95rem, 1.5vw, 1.05rem);
          line-height: 1.6;
          margin-bottom: 2rem;
        }
        
        .global-locations {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
        }
        
        .location-card {
          background-color: var(--white);
          border-radius: 12px;
          padding: 1.5rem;
          flex: 1;
          min-width: 200px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          transition: transform 0.3s ease;
        }
        
        .location-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }
        
        .location-title {
          color: var(--primary-green);
          font-weight: 600;
          font-size: clamp(0.95rem, 1.5vw, 1.05rem);
          margin-bottom: 1rem;
        }
        
        .location-list {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }
        
        .location-item {
          color: var(--text-dark);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.4;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .global-image {
          height: clamp(250px, 40vw, 400px);
          background: url('https://images.unsplash.com/photo-1592659762303-90081d34b277?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80') center/cover no-repeat;
          position: relative;
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }
        
        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent, rgba(31, 61, 43, 0.9));
          color: var(--white);
          padding: 1.5rem;
        }
        
        .image-title {
          font-weight: 600;
          font-size: clamp(1rem, 1.5vw, 1.1rem);
          color: var(--white);
        }
        
        .image-text {
          opacity: 0.9;
          font-size: clamp(0.8rem, 1.2vw, 0.9rem);
          color: var(--white);
        }
        
        /* ========== BACKGROUND COLORS ========== */
        .bg-soft-sage {
          background-color: var(--soft-sage);
        }
        
        /* ========== ANIMATIONS ========== */
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }
        
        /* ========== RESPONSIVE GRID GAPS ========== */
        .g-4 {
          --bs-gutter-x: clamp(1rem, 2vw, 1.5rem);
          --bs-gutter-y: clamp(1rem, 2vw, 1.5rem);
        }
        
        /* ========== COMPANY IMAGE ========== */
        .company-img {
          height: 300px;
        }

        .company-title {
          font-size: clamp(1.25rem, 3vw, 1.75rem);
        }

        .company-desc {
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
        }

        /* ========== MOBILE RESPONSIVE ========== */
        /* Extra small devices (portrait phones, <576px) */
        @media (max-width: 575.98px) {
          .home-hero-section {
            height: auto;
            min-height: 100vh;
            min-height: 100svh;
            padding-top: 80px;
            padding-bottom: 60px;
          }
          
          .hero-title {
            font-size: 1.75rem;
            margin-bottom: 0.75rem;
            line-height: 1.25;
          }
          
          .hero-subtitle {
            font-size: 0.95rem;
            margin-bottom: 1.5rem;
            line-height: 1.5;
            padding: 0 0.5rem;
          }
          
          .hero-cta {
            flex-direction: column;
            gap: 0.75rem;
            margin-bottom: 0;
            padding: 0 1rem;
          }
          
          .hero-cta .btn {
            width: 100%;
            padding: 14px 20px !important;
            font-size: 0.9rem;
            min-height: 48px;
          }
          
          /* Hide scroll indicator on mobile — not needed with auto-height hero */
          .scroll-indicator {
            display: none;
          }

          /* Section spacing */
          .section-padding {
            padding: 2rem 0;
          }

          /* Company section */
          .company-img {
            height: 200px;
          }

          .company-section {
            margin-bottom: 1.25rem !important;
          }

          .company-title {
            font-size: 1.15rem !important;
          }

          .company-desc {
            font-size: 0.9rem !important;
          }

          /* Cards */
          .card-img {
            height: 180px;
          }

          .card-content {
            padding: 1.25rem !important;
          }

          .card-title {
            font-size: 1.05rem;
          }

          .card-text {
            font-size: 0.88rem;
          }
          
          /* USP cards — stack icon + text vertically */
          .usp-card .d-flex {
            flex-direction: column;
            text-align: center;
          }
          
          .usp-number {
            margin: 0 auto 12px;
          }
          
          /* Mission/Vision — stack icon + text vertically */
          .mission-card .d-flex.align-items-start,
          .vision-card .d-flex.align-items-start {
            flex-direction: column;
            align-items: center !important;
            text-align: center;
          }

          .mission-icon,
          .vision-icon {
            margin-right: 0 !important;
            margin-bottom: 1rem;
          }

          .stat-box {
            padding: 0.75rem 0.5rem;
          }

          .stat-number {
            font-size: 1.15rem;
          }

          .stat-label {
            font-size: 0.78rem;
          }

          /* CTA card */
          .cta-card {
            padding: 1.5rem !important;
          }

          .cta-title {
            font-size: 1rem;
          }

          /* Stats section */
          .stats-icon {
            width: 55px;
            height: 55px;
            font-size: 1.3rem;
          }

          /* Categories */
          .categories-card {
            padding: 1.25rem !important;
          }

          .btn-category {
            padding: 8px 16px;
            font-size: 0.82rem;
          }

          /* Global Vision */
          .global-locations {
            flex-direction: column;
          }
          
          .location-card {
            width: 100%;
          }

          .global-image {
            height: 220px;
          }

          .global-icons {
            justify-content: center;
          }

          .global-icon-item {
            min-width: 100px;
          }

          .icon-circle {
            width: 55px;
            height: 55px;
          }
          
          /* Newsletter */
          .newsletter-form {
            flex-direction: column !important;
          }
          
          .newsletter-btn {
            width: 100%;
          }
          
          .newsletter-input {
            margin-bottom: 10px;
            font-size: 0.95rem;
            padding: 12px 14px;
          }

          .newsletter-card {
            padding: 1.5rem !important;
          }

          /* Section titles */
          .section-title {
            font-size: 1.4rem;
          }

          .section-subtitle {
            font-size: 0.88rem;
          }
        }

        /* Small devices (landscape phones, 576px-767px) */
        @media (min-width: 576px) and (max-width: 767.98px) {
          .home-hero-section {
            height: auto;
            min-height: 80vh;
            padding-top: 85px;
            padding-bottom: 50px;
          }

          .hero-title {
            font-size: 2rem;
          }
          
          .hero-subtitle {
            font-size: 1.05rem;
          }

          .hero-cta {
            margin-bottom: 30px;
          }
          
          .scroll-indicator {
            bottom: 20px;
          }
          
          .scroll-text {
            font-size: 0.82rem;
          }
          
          .scroll-arrow {
            font-size: 1.2rem;
          }

          .company-img {
            height: 240px;
          }
          
          .card-img {
            height: 200px;
          }
          
          .global-icons {
            justify-content: center;
          }

          .global-image {
            height: 260px;
          }

          /* Mission/Vision — stack icon + text */
          .mission-card .d-flex.align-items-start,
          .vision-card .d-flex.align-items-start {
            flex-direction: column;
            align-items: center !important;
            text-align: center;
          }

          .mission-icon,
          .vision-icon {
            margin-right: 0 !important;
            margin-bottom: 1rem;
          }
        }
        
        /* Medium devices (tablets, 768px-991px) */
        @media (min-width: 768px) and (max-width: 991.98px) {
          .home-hero-section {
            height: 75vh;
            min-height: 550px;
            padding-top: 80px;
          }
          
          .scroll-indicator {
            bottom: 30px;
          }
          
          .card-img {
            height: clamp(200px, 28vw, 230px);
          }

          .company-img {
            height: 260px;
          }

          .global-image {
            height: 300px;
          }
        }
        
        /* Large devices (desktops, 992px-1199px) */
        @media (min-width: 992px) and (max-width: 1199.98px) {
          .home-hero-section {
            height: 80vh;
            min-height: 600px;
            padding-top: 60px;
          }
          
          .scroll-indicator {
            bottom: 35px;
          }
          
          .card-img {
            height: 240px;
          }
        }
        
        /* Extra large devices (1200px+) */
        @media (min-width: 1200px) {
          .home-hero-section {
            height: 85vh;
            min-height: 700px;
            padding-top: 40px;
          }
          
          .scroll-indicator {
            bottom: 40px;
          }
          
          .card-img {
            height: 260px;
          }
        }
        
        /* ========== ACCESSIBILITY ========== */
        button:focus,
        input:focus,
        a:focus {
          outline: 2px solid var(--muted-gold);
          outline-offset: 2px;
        }
      `}</style>
    </>
  );
};

export default Home;